export class PlantIdRequest{
    unitcodeId? : number;
    plantId?:number

      constructor(unitcodeId ?: number,plantId?:number){
        this.unitcodeId = unitcodeId;
        this.plantId = plantId
    }

}